var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWetSignatureNew = function SvgWetSignatureNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none",
    viewBox: "0 0 64 64"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1B216B",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.925 4.694H16.889c-4.32 0-7.834 3.515-7.834 7.832V48.42c0 4.318 3.514 7.832 7.834 7.832h24.298c.997 0 1.947-.194 2.826-.535l-1.33-1.756a3 3 0 0 1-.365-.691c-.366.085-.74.142-1.13.142H16.888a4.994 4.994 0 0 1-4.989-4.989V12.526c0-2.75 2.24-4.99 4.99-4.99h12.173v14.29h17.146v1.51h2.843l.005-3.24L31.924 4.69zm-.02 14.29V8.501l11.658 10.483z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.08 36.174H14.767v2.843H42.08zM42.08 27.58H14.768v2.843H42.08zM42.08 44.77H14.768v2.843H42.08zM26.24 18.984H14.765v2.843H26.24zM53.48 24.76h-8.512c-.809 0-1.464.685-1.464 1.526V52.16c0 .202.052.399.126.587.051.126.106.251.188.358l1.488 1.966 2.77 3.656a1.423 1.423 0 0 0 2.075.24q.125-.106.226-.237l4.257-5.625c.202-.268.314-.604.314-.945V26.286c0-.84-.655-1.526-1.463-1.526zm-6.328 28.705h4.14l-2.07 2.07-2.062-2.062zm-.72-25.849h5.58v22.859h-5.58z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h64v64H0z"
  })))));
};
export { SvgWetSignatureNew as Icon };
export default __webpack_public_path__ + "static/media/2e6cbf0fd07080fd25eb21f2fcde9c94.svg";